export default __webpack_public_path__ + "static/media/Frame 1.c1057e4d.png";